import { z } from 'zod';

import { PropertyId } from '../BrandedIds';
import { InspectionType } from '../loan/Inspection';
import { InspectionOrderedReason } from '../loan/ReportableEvent';
import { zodDateOrString } from '../utils';
import { BaseLoanEvent } from './BaseLoanEvent';

export const AddInspectionOrderEvent = BaseLoanEvent.extend({
  type: z.literal('addInspectionOrder'),
  date: zodDateOrString,
  propertyId: PropertyId,
  inspectionType: InspectionType,
  inspectionReason: InspectionOrderedReason,
  vendorName: z.string(),
});

export type AddInspectionOrderEvent = z.infer<typeof AddInspectionOrderEvent>;
